import React from 'react';
import { View } from 'react-native';
import { Feather } from '@expo/vector-icons';

import { formatRosterDateRange } from '../../../../common/utils/people/roster';
import Text from '../../../components/text/Text';
import Card from '../../../design/components/Card';
import { useTheme } from '../../../theme';
import { useThemedStyles } from '../../../hooks/useThemedStyles';
import { ROSTER_DATE_FORMAT } from '../rosterHelpers';

/**
 * Hours worked so far in the current pay cycle, at the top of My timesheets.
 * Props: payCycleHours (getMyPayCycleHours result: startDate, endDate, roundedNetWorkedHours)
 */
const PayCycleHoursCard = ({ payCycleHours }) => {
	const styles = useThemedStyles(createStyles);
	const { theme: { ui: { colors } } } = useTheme();

	const hours = Number(payCycleHours.roundedNetWorkedHours) || 0;
	// Up to two decimals without trailing zeros, like Deputy: 32.5, 7.75, 0.
	const hoursLabel = String(Number(hours.toFixed(2)));
	const unit = hours === 1 ? 'hour' : 'hours';
	const dates = formatRosterDateRange(payCycleHours.startDate, payCycleHours.endDate, ROSTER_DATE_FORMAT);

	return (
		<Card style={styles.card} accessibilityLabel={`This pay cycle, ${hoursLabel} ${unit} worked, ${dates}`}>
			<Feather name="clock" size={44} color={colors.accent} />
			<View style={styles.main}>
				<Text style={styles.label}>This pay cycle</Text>
				<View style={styles.hoursRow}>
					<Text style={styles.hours}>{hoursLabel}</Text>
					<Text style={styles.unit}>{unit}</Text>
				</View>
				<Text style={styles.dates} numberOfLines={1}>{dates}</Text>
			</View>
		</Card>
	);
};

const createStyles = ({ ui: { colors, type, space, radius } }) => ({
	card: {
		flexDirection: 'row',
		alignItems: 'center',
		gap: space.lg,
		borderRadius: radius.hero,
	},
	main: {
		flex: 1,
		minWidth: 0,
		gap: space.xxs,
	},
	label: {
		...type.secondarySemibold,
		color: colors.textSecondary,
	},
	hoursRow: {
		flexDirection: 'row',
		alignItems: 'baseline',
		gap: 6,
	},
	hours: {
		...type.hero,
		color: colors.text,
	},
	unit: {
		...type.bodyStrong,
		color: colors.text,
	},
	dates: {
		...type.secondary,
		color: colors.textSecondary,
	},
});

export default PayCycleHoursCard;
